import Hero from './Hero';
import TrialResultsComponent from './TrialResultsComponent';
import MissionAndValuesSection from 'components/MissionAndValuesSection';
import LatestNews from './LatestNews';
import Solutions from './Solutions';
import AboutUs from './AboutUs';
import Products from './Products';
import Instagram from './Instagram';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectHomepage, fetchHomepage } from 'store/slices/HomepageSlice';
import { fetchLatestPostsForHomepage } from 'store/slices/BlogSlice';
import { homepage_posts_limit } from 'api/constants';

export const Homepage = () => {
    const dispatch = useDispatch();

    const { mission_background_image, mission_cards, mission_title } = useSelector(selectHomepage);

    React.useEffect(() => {
        // @ts-ignore
        dispatch(fetchLatestPostsForHomepage({ limit: homepage_posts_limit }));
        // @ts-ignore
        dispatch(fetchHomepage());
    }, [dispatch]);

    return (
        <>
            <Hero />
            <Solutions />
            <AboutUs />
            <MissionAndValuesSection background={mission_background_image} title={mission_title} data={mission_cards} />
            <Products />
            <TrialResultsComponent />
            <LatestNews />
            <Instagram />
            <DefaultForm />
        </>
    );
};
